import { SHOP_THIS_STORE_ACTIONS } from './ShopThisStore.constants';

const initialState = {
  shopThisStoreHorizontalPlpProducts: [],
  shopThisStoreL1categories: [],
  shopThisStoreL2categories: [],
  shopThisStoreL1Selection: {},
  shopThisStoreL1SelectionLoaded: false,
  shopThisStoreL2GroupingSelection: {},
  shopThisStoreL2GroupingSelectionLoaded: false,
  isShopThisStoreL1categoriesLoading: false,
  isShopThisStoreL2categoriesLoading: false,
  selectedCategory: {},
  selectedGroupId: '',
  loadedInShopThisStore: false,
  isShopThisStoreHplpLoaded: true,
  showShopThisStoreNotification: false,
  shopThisStoreL1categoriesFetched: false,
  selectedStoreL1Categories: [],
  selectedStoreL2Categories: [],
};

// eslint-disable-next-line complexity
const ShopThisStoreReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SHOP_THIS_STORE_ACTIONS.SET_HORIZONTAL_PLP_PRODUCTS:
      return { ...state, shopThisStoreHorizontalPlpProducts: action.data };
    case SHOP_THIS_STORE_ACTIONS.SET_L1_CATEGORIES:
      return { ...state, shopThisStoreL1categories: action.data };
    case SHOP_THIS_STORE_ACTIONS.SET_L1_CATEGORIES_FETCHED:
      return { ...state, shopThisStoreL1categoriesFetched: true };
    case SHOP_THIS_STORE_ACTIONS.SET_L2_CATEGORIES:
      return { ...state, shopThisStoreL2categories: action.data };
    case SHOP_THIS_STORE_ACTIONS.SET_L1_CATEGORY_SELECTION:
      return { ...state, shopThisStoreL1Selection: action.payload.categoryItem };
    case SHOP_THIS_STORE_ACTIONS.SET_L1_CATEGORY_SELECTION_LOADED:
      return { ...state, shopThisStoreL1SelectionLoaded: action.payload };
    case SHOP_THIS_STORE_ACTIONS.SET_L2_CATEGORY_GROUPING_SELECTION:
      return { ...state, shopThisStoreL2GroupingSelection: action.payload.categoryItem };
    case SHOP_THIS_STORE_ACTIONS.SET_L2_CATEGORY_GROUPING_SELECTION_LOADED:
      return { ...state, shopThisStoreL2GroupingSelectionLoaded: action.payload };
    case SHOP_THIS_STORE_ACTIONS.SET_L1_CATEGORIES_LOADING:
      return { ...state, isShopThisStoreL1categoriesLoading: action.payload.isLoading };
    case SHOP_THIS_STORE_ACTIONS.SET_L2_CATEGORIES_LOADING:
      return { ...state, isShopThisStoreL2categoriesLoading: action.payload.isLoading };
    case SHOP_THIS_STORE_ACTIONS.SET_SELECTED_L1_CATEGORY_CONTENT:
      return { ...state, selectedCategory: action.payload.selectedCategory };
    case SHOP_THIS_STORE_ACTIONS.SET_SELECTED_L2_CATEGORY_GROUP_ID:
      return { ...state, selectedGroupId: action.payload.selectedGroupId };
    case SHOP_THIS_STORE_ACTIONS.LOADED_IN_SHOP_THIS_STORE:
      return { ...state, loadedInShopThisStore: action.payload };
    case SHOP_THIS_STORE_ACTIONS.SHOP_THIS_STORE_HPLP_LOADED:
      return { ...state, isShopThisStoreHplpLoaded: action.payload };
    case SHOP_THIS_STORE_ACTIONS.SHOW_SHOP_THIS_STORE_NOTIFICATION:
      return { ...state, showShopThisStoreNotification: action.payload };
    case SHOP_THIS_STORE_ACTIONS.SET_FILTERED_L2_AND_L1_CATEGORIES:
      return { ...state, filteredL2AndL1Categories: action.data };
    case SHOP_THIS_STORE_ACTIONS.SET_IS_DEFAULT_CATEGORIES_LOADED:
      return { ...state, isDefaultCategoriesLoaded: action.payload };
    case SHOP_THIS_STORE_ACTIONS.SET_SELECTED_STORE_L1_CATEGORIES:
      return { ...state, selectedStoreL1Categories: action.payload };
    case SHOP_THIS_STORE_ACTIONS.SET_SELECTED_STORE_L2_CATEGORIES:
      return { ...state, selectedStoreL2Categories: action.payload };
    default:
      return state;
  }
};

export default ShopThisStoreReducer;
